import axios from "axios";

export const fetchPredictions = async (baseUrl, value, lng) => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await axios.get(
            `${baseUrl}/index.php?r=api/destinationguides/search`,
            {
                headers: {
                    'x-authorization-token': token
                },
                params: {
                    name: value,
                    lng: lng
                }
            }
        ) || {}

        return data
    } catch (err) {
        console.error('Error fetching guide predictions: ', err)
    }
}

export const fetchSuggestions = async (baseUrl, value, lng) => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await axios.get(
            `${baseUrl}/index.php?r=api/destinations/suggestions`,
            {
                headers: {
                    'x-authorization-token': token
                },
                params: {
                    name: value,
                    lng: lng
                }
            }
        ) || {}

        return data
    } catch (err) {
        console.error('Error fetching guide predictions: ', err)
    }
}

export const fetchAutocompleteDestinations = async (baseUrl, value, lng) => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await axios.get(
            `${baseUrl}/index.php?r=api/destinations/searchdestinations`,
            {
                headers: {
                    'x-authorization-token': token
                },
                params: {
                    name: value,
                    lng: lng
                }
            }
        ) || {}

        return data
    } catch (err) {
        console.error('Error fetching guide autocomplete: ', err)
    }
}

